import { ComponentPropsWithoutRef, forwardRef, ReactElement } from 'react';

import * as styles from './DividerLine.css';

export const DividerLine = forwardRef<
  HTMLDivElement,
  Omit<
    ComponentPropsWithoutRef<'div'>,
    'onChange' | 'onKeyDown' | 'onKeyUp'
  > & {
    vertical?: boolean;
    height?: number | string; // percentage height for vertical divider
  }
>(function Root(props, ref): ReactElement {
  return props.vertical ? (
    <div
      className={styles.dividerVertical}
      style={{
        height: props.height,
        ...props.style,
      }}
    />
  ) : (
    <div className={styles.dividerHorizontal} {...props} />
  );
});
